import { FC } from 'react';

type Props = {
	className?: string;
};

const LogoutIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			className={className}>
			<path
				d='M11.6667 2.57918C11.2858 2.52701 10.8962 2.5 10.5 2.5C6.08173 2.5 2.5 5.85787 2.5 10C2.5 14.1422 6.08173 17.5 10.5 17.5C10.8962 17.5 11.2858 17.473 11.6667 17.4208'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M17.4993 10.0001H9.16602M17.4993 10.0001C17.4993 9.41658 15.8374 8.32636 15.416 7.91675M17.4993 10.0001C17.4993 10.5836 15.8374 11.6738 15.416 12.0834'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default LogoutIcon;
